import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FETCH_STAT_COMPARISON } from '../../../../../store/js/modules/statspro/stat-comparison/actions';
import { Loader } from '../../../../../../../common/react/components/Loader';
import { StatComparisonRow } from './StatComparisonRow';
import {
    statComparisonDataSelector,
    statComparisonDataTypeSelector,
    statComparisonNavSelector
} from '../../../../../store/js/modules/statspro/stat-comparison/selectors';
import { composeData, composeRows } from '../utils';

export const StatComparisonMain = ({ playerIds }) => {
    const dispatch = useDispatch();
    const nav = useSelector(statComparisonNavSelector);
    const seasons = useSelector(
        (state) =>
            state.seasons[`competition_${nav.competition.id}`]?.list ?? []
    );
    const season = seasons.find((item) => item.id === nav.season.id);
    const dataType = useSelector(statComparisonDataTypeSelector);
    const playerOneCareerData = useSelector((state) =>
        PULSE.app.redux.selectors.statsplayerprofile.item(state, playerIds[1])
    );
    const playerTwoCareerData = useSelector((state) =>
        PULSE.app.redux.selectors.statsplayerprofile.item(state, playerIds[2])
    );
    const playersSeasonData = useSelector(statComparisonDataSelector);
    const [composedPlayersData, setComposedPlayersData] = useState(null);

    // Fetch season data
    useEffect(() => {
        if (playerIds[1] && !playersSeasonData[playerIds[1]]) {
            dispatch(
                FETCH_STAT_COMPARISON.request({
                    playerId: playerIds[1]
                })
            );
        }
    }, [playerIds[1]]);

    useEffect(() => {
        if (playerIds[2] && !playersSeasonData[playerIds[2]]) {
            dispatch(
                FETCH_STAT_COMPARISON.request({
                    playerId: playerIds[2]
                })
            );
        }
    }, [playerIds[2]]);

    /**
     * Get rows for the selected category
     */
    const rows = useMemo(
        () => composeRows(nav.season.id, nav.category),
        [nav.category]
    );

    // Update the data when the nav changes
    useEffect(() => {
        if (nav.season.id === -1) {
            // career stats
            setComposedPlayersData([
                composeData(rows, playerOneCareerData, dataType.type),
                composeData(rows, playerTwoCareerData, dataType.type)
            ]);
        } else {
            // season stats
            setComposedPlayersData([
                composeData(
                    rows,
                    playersSeasonData[playerIds[1]]?.find(
                        (item) => item.seasonId === season.providerId
                    ),
                    dataType.type
                ),
                composeData(
                    rows,
                    playersSeasonData[playerIds[2]]?.find(
                        (item) => item.seasonId === season.providerId
                    ),
                    dataType.type
                )
            ]);
        }
    }, [
        nav.season.id,
        rows,
        playerOneCareerData,
        playerTwoCareerData,
        playersSeasonData,
        dataType.type
    ]);

    // Loader and empty state for data
    if (!composedPlayersData) {
        return (
            <div className="stat-comparison__loader">
                <Loader />
            </div>
        );
    }

    return (
        <div className="stat-comparison__stats-wrapper">
            {rows.map((row, i) => (
                <StatComparisonRow
                    key={i}
                    statName={row.name}
                    data={[
                        composedPlayersData[0].find(
                            (item) => item.name === row.name
                        ),
                        composedPlayersData[1].find(
                            (item) => item.name === row.name
                        )
                    ]}
                />
            ))}
        </div>
    );
};

StatComparisonMain.propTypes = {
    playerIds: PropTypes.object.isRequired
};
